import {
	APPROVE_ARTICLES_GET_ARTICLES,
	APPROVE_ARTICLES_GET_ARTICLES_FAILURE,
	APPROVE_ARTICLES_GET_ARTICLES_SUCCESS,
	APPROVE_ARTICLES_REMOVE_ARTICLES,
	APPROVE_ARTICLES_REMOVE_ARTICLES_FAILURE,
	APPROVE_ARTICLES_REMOVE_ARTICLES_SUCCESS,
	APPROVE_ARTICLES_PROPS_CHANGED
} from "./actions";
import {MANAGE_ARTICLES_PROPS_CHANGED} from "../manage/actions";

export const dispatchOnApproveArticlesGetArticles = () => dispatch => {
	dispatch({type: APPROVE_ARTICLES_GET_ARTICLES});
};

export const dispatchOnApproveArticlesGetArticlesSuccess = (response) => dispatch => {
	dispatch({
		type: APPROVE_ARTICLES_GET_ARTICLES_SUCCESS,
		articles: response.data,
		pagination: response.pagination,
	});
};

export const dispatchOnApproveArticlesGetArticlesFailure = (error) => dispatch => {
	dispatch({type: APPROVE_ARTICLES_GET_ARTICLES_FAILURE, error});
};

export const dispatchOnApproveArticlesRemoveArticles = () => dispatch => {
	dispatch({type: APPROVE_ARTICLES_REMOVE_ARTICLES});
};

export const dispatchOnApproveArticlesRemoveArticlesSuccess = (article, index, response) => dispatch => {
	dispatch({
		type: APPROVE_ARTICLES_REMOVE_ARTICLES_SUCCESS,
		article,
		index,
		response
	});
};

export const dispatchOnApproveArticlesRemoveArticlesFailure = (error) => dispatch => {
	dispatch({type: APPROVE_ARTICLES_REMOVE_ARTICLES_FAILURE, error});
};

export const dispatchOnApproveArticlesRemoveModeChanged = (article, index, inRemoveMode) => dispatch => {
	dispatch({
		type: APPROVE_ARTICLES_PROPS_CHANGED,
		article,
		index,
		inRemoveMode
	});
};

export const dispatchOnApproveArticlesClickedArticleIdChanged = (clickedArticleId) => dispatch => {
	dispatch({
		type: APPROVE_ARTICLES_PROPS_CHANGED,
		clickedArticleId,
	})
};